import styled from 'styled-components';
import { ModalTitle } from 'legacyComponents/styled/lib';

export const ModalTitleWrapper = styled(ModalTitle)`
  display: inline-block;
  margin-top: 2rem;
  margin-left: 2rem;
`;
